import React, { useState } from 'react';
import TemplateLibraryModal from '../components/email/campaigns/TemplateLibraryModal';

const TestTemplates: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h1 className="text-3xl font-bold mb-4">Template Library Test</h1>
          <p className="text-gray-600 mb-6">
            Click the button below to test the template library. You should see 15 pre-built templates.
          </p>

          <button
            onClick={() => setShowModal(true)}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700"
          >
            Open Template Library
          </button>
        </div>

        {selectedTemplate && (
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-2xl font-bold mb-4">Selected Template</h2>
            
            <div className="space-y-4">
              <div>
                <label className="font-semibold text-gray-700">Name:</label>
                <p className="text-gray-900">{selectedTemplate.name}</p>
              </div>

              <div>
                <label className="font-semibold text-gray-700">Industry:</label>
                <p className="text-gray-900">{selectedTemplate.industry}</p>
              </div>

              <div>
                <label className="font-semibold text-gray-700">Spam Score:</label>
                <p className="text-gray-900">{selectedTemplate.spam_score}/100</p>
              </div>

              <div>
                <label className="font-semibold text-gray-700">Subject:</label>
                <p className="text-gray-900 font-mono text-sm bg-gray-50 p-3 rounded">
                  {selectedTemplate.subject}
                </p>
              </div>

              <div>
                <label className="font-semibold text-gray-700">Body:</label>
                <p className="text-gray-900 font-mono text-sm bg-gray-50 p-3 rounded whitespace-pre-wrap">
                  {selectedTemplate.body}
                </p>
              </div>

              <div>
                <label className="font-semibold text-gray-700">Variables:</label>
                <div className="flex gap-2 flex-wrap mt-2">
                  {selectedTemplate.variables.map((v: string) => (
                    <span key={v} className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-mono">
                      {`{{${v}}}`}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        <TemplateLibraryModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onSelectTemplate={(template) => {
            setSelectedTemplate(template);
            setShowModal(false);
            console.log('Selected template:', template);
          }}
        />
      </div>
    </div>
  );
};

export default TestTemplates;
